import { NgModule } from '@angular/core';
import { environment } from '@environments/environment';
import { PL_API_CONFIG } from 'pl-core-services';

@NgModule({
  providers: [
    {
      provide: PL_API_CONFIG,
      useValue: {
        auth: environment.apps.auth,
        kanga: environment.apps.kanga,
        room: environment.apps.room,
        version: environment.git_sha,
        django_login_url: environment.django_login_url,
        gateway: environment.apps.gateway,
      },
    },
  ],
})
export class PlApiModule {}
